<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiLogoutVariant } from "@mdi/js"

export default {
  name: "LogoutVariantIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiLogoutVariant,
    }
  }
}
</script>
